module.exports = __webpack_public_path__ + "img/Helpdesk_prod_v3.32aadbd0.png";